/* eslint-disable */
// import OggConverterWorker from "worker-loader!../workers/oggConverter.worker";
// import OggDecoderWorker from "worker-loader!../workers/oggDecoder.worker";
import Mp3ConverterWorker from "worker-loader!../workers/mp3Converter.worker";
import AudioProcessWorker from "worker-loader!../workers/audioProcess.worker";
/* eslint-enable */
import request from './request';
import {AUDIO} from '../constants/urlConstants';
import 'whatwg-fetch';
import isNumber from 'lodash/isNumber';
import recorderStore from '../components/recorder/store';

import metronomeTickNoGap from '../assets/audio/new-metronome.wav';
import metronomeTickGap from '../assets/audio/new-metronome.mp3';
import silenceMp3 from '../assets/audio/silence.mp3';
import {isMacOs} from "./deviceUtility";
import {MIDIFile} from './MIDIFile';
import {BPM_MAX, BPM_MIN} from '../constants/constants';
import device from "current-device";
import {getDeviceLatency} from "./userUtility";
import {LatencyTestError} from "../constants/enums";
import mean from 'lodash/mean';
import {isFirefox, isIos} from "./screenUtility";
import {getStreamIfAvailable} from "./awsUtility";


export const oggSupported = (!!document.createElement('video').canPlayType('audio/ogg'));

let _audioContext = null;


export function roundDurationToBpm(bpm, duration) {
    const beatLength = (60 / bpm);
    const numBeats = Math.round(duration / beatLength);
    return numBeats * beatLength || duration;
}

export function isMidi(fileType) {
    return fileType === 'audio/midi' || fileType === 'audio/mid';
}

export function getAudioContextForIos() {
    if (!_audioContext) {
        _audioContext = createAudioContext();
    }
    try {
        const silence = new Audio(silenceMp3);
        try {
            silence.play().catch(() => {
            });
        } catch (err) {
            console.error(err);
        }

        _audioContext.close(); // dispose old context
        _audioContext = createAudioContext();
    } catch (err) {
        console.log('error creating context: ' + err);
    }

    return _audioContext;
}

export function allowPlayback() {
    return !isIos() || getAudioContext().sampleRate === 44100;
}

export function getAudioContext() {
    if (!_audioContext) {
        _audioContext = createAudioContext();
    }

    if (_audioContext.state === 'suspended' || _audioContext.state === 'interrupted') {
        _audioContext.resume();
    }

    return _audioContext;
}

function createAudioContext() {
    try {
        let AudioContext = window.AudioContext || window.webkitAudioContext;
        let audioContext = new AudioContext();
        console.log('CREATING A NEW AUDIO CONTEXT' + audioContext.sampleRate);
        return audioContext;
    } catch (err) {
        console.log(err);
    }
}

export function createOfflineAudioContext(numChannels, samples, sampleRate) {
    return (typeof window.webkitOfflineAudioContext !== 'undefined') ? new (window.webkitOfflineAudioContext)(numChannels, samples, sampleRate) : new (OfflineAudioContext)(numChannels, samples, sampleRate);
}

export function extractBuffer(buffer) {
    let peaks = [];
    if (buffer && buffer.length) {
        buffer = buffer.getChannelData(0);
        let sections = 275;
        let len = Math.floor(buffer.length / sections);
        for (let i = 0; i < sections; i += 1) {
            peaks.push(bufferMeasure(i * len, len, buffer) * 230);
        }
    }
    return peaks;
}


export function audioStrech(buffer, pitch, speed) {
    return new Promise((resolve, reject) => {

        let worker = new AudioProcessWorker();
        worker.onmessage = event => {
            if (speed < 1) {
                buffer = getAudioContext().createBuffer(buffer.numberOfChannels, event.data[0].length, buffer.sampleRate);
            }
            buffer.getChannelData(0).set(event.data[0]);
            buffer.getChannelData(1).set(event.data[1]);
            resolve(buffer);
            worker.terminate();
        };

        worker.postMessage({left: buffer.getChannelData(0), right: buffer.getChannelData(1), pitch, speed});
    });
}

// export function decodeToOgg(buffer) {
//     return new Promise((resolve, reject) => {
//         let worker = new OggDecoderWorker();
//         let ret = [];
//         worker.onmessage = (event) => {
//             let data = event.data.data;
//             if (data === null) {
//                 let res = [];
//                 ret.forEach((chunk) => {
//                     res = res.concat(chunk)
//                 });
//                 resolve(Uint8Array.from(res).buffer);
//                 worker.terminate();
//                 res = null;
//                 ret = null;
//                 worker = null;
//             } else {
//                 ret.push(data);
//             }
//
//         };
//         worker.postMessage({
//             buffer: new Uint8Array(buffer)
//         });
//
//         worker.onerror = (err) => {
//             console.log(err);
//             worker.terminate();
//             resolve(null);
//         };
//     });
// }


function bufferMeasure(position, length, data) {
    let sum = 0.0;
    for (let i = position; i <= (position + length) - 1; i++) {
        sum += Math.pow(data[i], 2);
    }
    return Math.sqrt(sum / data.length);
}

// // function renderAudioElement(blob, type) {
// //     const audio = document.createElement('audio');
// //     audio.controls = 'controls';
// //     audio.type = type;
// //     audio.src = renderURL(blob);
// //     return audio;
// // }
//
// function renderURL(blob) {
//     return (window.URL || window.webkitURL).createObjectURL(blob);
// }


export function readFileAsArray(file) {
    return new Promise(resolve => {
        let reader = new FileReader();
        reader.onload = (event) => {
            resolve(event.target.result);
        };
        reader.readAsArrayBuffer(file);
    });
}

/**
 * Generates peaks for audio file
 * @param arrayBuffer
 */
export function analyzeBuffer(arrayBuffer, type) {
    return new Promise(async (resolve, reject) => {
        if (isMidi(type)) {
            let song = parseMidiBuffer(arrayBuffer);
            // todo implement analyze for midi
            // console.log(song);
            resolve({peaks: [], song: song, duration: song.duration});
        } else {
            getAudioContext().decodeAudioData(arrayBuffer, (buffer) => {
                resolve({peaks: extractBuffer(buffer), buffer: buffer, duration: buffer.duration});
            }, err => {
                console.log('error decoding buffer: ' + err);
                reject(err);
            });
        }
    })
}

function getFirstSampleFramesAboveThreshold(buffer, threshold = 0.1, ignoreFirst = 0) {
    let max = 0;
    for (let i = 0; i < buffer.numberOfChannels; i++) {
        let channel = buffer.getChannelData(i);
        for (let j = 0; j < channel.length; j++) {
            if (j > ignoreFirst * buffer.sampleRate) {
                max = Math.max(max, channel[j]);
            }
        }
    }

    for (let i = 0; i < buffer.numberOfChannels; i++) {
        let channel = buffer.getChannelData(i);
        for (let j = 0; j < channel.length; j++) {
            if (Math.abs(channel[j]) > threshold * max && j > ignoreFirst * buffer.sampleRate) {
                return j;
            }
        }
    }

    return null;
}

export function getFirstSampleAboveThreshold(buffer, threshold = 0.1, ignoreFirst = 0) {
    return Math.max(0, (getFirstSampleFramesAboveThreshold(buffer, threshold, ignoreFirst)) / buffer.sampleRate);
}


export const WAVE_NUM_SAMPLES = 500;

export function calculateWave(audioBuffer, latencyOffset = 0, numChunks = WAVE_NUM_SAMPLES) {
    let wave = [];
    // latencyOffset = 5;
    if (audioBuffer && audioBuffer.length) {
        let wave = [];
        const buffer = audioBuffer.getChannelData(0);
        let len = Math.floor(buffer.length / numChunks);
        for (let i = 0; i < numChunks; i++) {
            let max = 0;
            for (let j = i * len; j < (i + 1) * len; j++) {
                const index = Math.floor(Math.min(buffer.length - 1, j + latencyOffset * audioBuffer.sampleRate));
                max = Math.max(buffer[index], max) || max;
            }
            wave.push(max);
        }
        let max = Math.max(...wave);
        wave = wave.map(w => w / max);
        return wave;
    }
    return wave;


    for (let i = 0; i < buffer.numberOfChannels; i++) {
        let channel = buffer.getChannelData(i);
        for (let j = 0; j < channel.length; j++) {
            if (Math.abs(channel[j]) > threshold * max) {
                console.log(j)
                return j;
            }
        }
    }

    return null;
}

export function resampleWave(wave, newSampleSize) {
    if (wave) {
        const fixedWave = [];
        for (let i = 0; i < newSampleSize; i++) {
            fixedWave.push(Math.max(...wave.slice(i * (WAVE_NUM_SAMPLES / newSampleSize), (i + 1) * (WAVE_NUM_SAMPLES / newSampleSize))));
        }
        return fixedWave;
    }
}


export function parseMidiBuffer(arrayBuffer) {
    let midiFile = new MIDIFile(arrayBuffer);
    return midiFile.parseSong();
}

export async function convertToMono(buffer) {
    let ac = new createOfflineAudioContext(1, buffer.duration * buffer.sampleRate, buffer.sampleRate);
    let source = ac.createBufferSource();
    source.buffer = buffer;
    let merger = ac.createChannelMerger(buffer.numberOfChannels);
    source.connect(merger);
    merger.connect(ac.destination);
    source.start();
    return await ac.startRendering();
}

/**
 * Convert a file to an MP3 file
 * @param buffer
 * @param forceMono
 * @returns {Promise}
 */
export async function convertToMp3(buffer, forceMono = false) {
    let worker = new Mp3ConverterWorker();
    if (forceMono) {
        buffer = convertToMono(buffer);
    }
    let bufferLeft = buffer.getChannelData(0);
    let bufferRight;
    if (buffer.numberOfChannels === 2) {
        bufferRight = buffer.getChannelData(1);
    }

    worker.postMessage({
        bufferLeft: bufferLeft,
        bufferRight: bufferRight,
        numChannels: buffer.numberOfChannels,
        sampleRate: buffer.sampleRate,
        forceMono: forceMono
    });

    return new Promise(resolve => {
        worker.onmessage = (event) => {
            let audioBlob = event.data.blob;
            // let type = event.data.type;
            resolve(audioBlob);
            worker.terminate();
        };
    });
}

/**
 * Convert a file to an MP3 file
 * @param buffer
 * @returns {Promise}
 */
// export function convertToOgg(buffer) {
//     let worker = new OggConverterWorker();
//     let bufferLeft = buffer.getChannelData(0);
//     let bufferRight;
//     if (buffer.numberOfChannels === 2) {
//         bufferRight = buffer.getChannelData(1);
//     }
//
//     worker.postMessage({
//         bufferLeft: bufferLeft,
//         bufferRight: bufferRight,
//         numChannels: buffer.numberOfChannels,
//         sampleRate: buffer.sampleRate
//     });
//
//     return new Promise(resolve => {
//         worker.onmessage = (event) => {
//             let audioBlob = event.data.blob;
//             resolve(audioBlob);
//         }
//     });
//
// }


/**
 * Generates the S3 stored file its bpm
 * @param fileId    {String}    The file to generate bpm to
 * @returns {Promise.<void>}
 */
export async function generateAudioFileBPM(fileId) {
    try {
        return await request(`${AUDIO}-gw/${fileId}`);
    } catch (err) {
        throw err;
    }
}

/**
 * Request to update file bpm, creates a new file
 * @param fileId    {String}    The file to generate bpm to
 * @param fromBPM {Number}  The current file bpm
 * @param toBPM {Number}    The requested bpm
 * @param pitch
 * @returns {Promise.<void>}
 */
export async function updateAudioFileBPMPitch(fileId, fromBPM, toBPM, pitch) {
    try {
        return await request(`${AUDIO}/${fileId}`, {method: 'PUT', body: {fromBpm: fromBPM, toBpm: toBPM, pitch: pitch}}, true);
    } catch (err) {
        throw err;
    }
}


/**
 * return an audiobuffer of all loopers
 * @param loopers object {buffer: audio buffer, loop: true/false, volume: volume}
 * @returns the new audio buffer
 */
export function concatAudioBuffers(loopers) {
    const maxDuration = Math.max.apply(Math, loopers.map(looper => looper.buffer.duration));
    const numChannels = 2;
    const sampleRate = loopers[0].buffer.sampleRate;
    let output = getAudioContext().createBuffer(numChannels, sampleRate * maxDuration, sampleRate);

    loopers.forEach(looper => {
        if (looper.volume > 0) {
            for (let channel = 0; channel < numChannels; channel++) {
                let bufferLength = looper.buffer.getChannelData(channel % looper.buffer.numberOfChannels).length;
                let bufferFixedLength = looper.loop ? maxDuration : bufferLength;
                for (let i = 0; i < bufferFixedLength; i++) {
                    output.getChannelData(channel)[i] += (looper.volume / 0.5) * looper.buffer.getChannelData(channel % looper.buffer.numberOfChannels)[i % (bufferLength)];
                }
            }
        }
    });
    return output;
}

export function copyBuffer(target, source, channel = null, from = 0, to = 0) {
    let numChannels = source.numberOfChannels;
    let startChannel = 0;
    if (isNumber(channel)) {
        // copy only a single channel
        startChannel = channel;
        numChannels = channel + 1;
    }
    // console.log('@@@ copy buffer called: target' + target.getChannelData(0).length + ', source: ' + source.getChannelData(0).length + ', from: ' + from);
    for (let c = startChannel; c < numChannels; c++) {
        let subarray = source.getChannelData(c).subarray(from);
        if (to + subarray.length > target.getChannelData(c).length) {
            subarray = subarray.subarray(0, target.getChannelData(c).length)
            // console.warn('trimming down copy from: ' + to + ' to: ' + (target.getChannelData(c).length));
        }
        if (typeof target.copyToChannel === 'function') {
            target.copyToChannel(subarray, c, to);
        } else {
            target.getChannelData(c).set(new Float32Array(subarray), to);
        }
    }
}

let metronomeSoundBufferGap = null;
let metronomeSoundBufferNoGap = null;


async function getAndDecode(file) {
    let response = await fetch(file);
    let metronomeArrayBuffer = await response.arrayBuffer();
    return new Promise((resolve, reject) => {
        getAudioContext().decodeAudioData(metronomeArrayBuffer, (buffer) => {
            resolve(buffer);
        }, (err) => {
            console.log(err);
            reject(err);
        })
    });
}


export async function prepareMetronomeGap() {
    if (metronomeSoundBufferGap === null) {
        metronomeSoundBufferGap = await getAndDecode(metronomeTickGap);
    }
    return metronomeSoundBufferGap;
}

export async function prepareMetronomeNoGap() {
    if (metronomeSoundBufferNoGap === null) {
        metronomeSoundBufferNoGap = await getAndDecode(metronomeTickNoGap);
    }
    return metronomeSoundBufferNoGap;
}


export async function prepareMetronomeLegacy(bpm, timeSignatureMeter) {
    let metronomeSoundBuffer = await prepareMetronomeNoGap();
    let sampleRate = metronomeSoundBuffer.sampleRate;

    bpm = bpm || 120;
    timeSignatureMeter = timeSignatureMeter || 4;
    let beatLength = Math.round(60 / bpm * sampleRate * (4 / timeSignatureMeter));

    let metronomeBuffer = getAudioContext().createBuffer(1, beatLength, sampleRate);
    copyBuffer(metronomeBuffer, metronomeSoundBuffer, 0);

    return metronomeBuffer;

}

/**
 * Implement the metronome functionality returning an object with multiple functions
 * @param bpm   {Number}   The initialized bpm to play to
 * @returns {Object}    play: play    {Function}  Plays the metronome,
 *          stop: stop  {Function}  Stops the metronome,
 *          changeBpm: changeBpm    {Function}  Change the bpm
 */
export async function metronome(bpm = 120, timeSignatureMeter = 4) {
    let buffer = null;
    let source = null;
    let gainNode = null;
    let prevVolume = 1;
    let volume = 1;

    function stop() {
        try {
            source.stop();
        } catch (err) {
        }
    }

    function mute() {
        prevVolume = volume;
        changeVolume(0);
    }

    function unmute() {
        changeVolume(prevVolume);
    }

    function changeVolume(newVolume) {
        let prevVol = volume;
        if (newVolume > 0) {
            volume = newVolume;
        }
        if (gainNode !== null) {
            let currentTime = getAudioContext().currentTime;
            gainNode.gain.setValueAtTime(prevVol, currentTime);
            gainNode.gain.linearRampToValueAtTime(newVolume, currentTime + 0.01);
        }
    }

    function play(loop = true) {
        source = getAudioContext().createBufferSource();
        source.buffer = buffer;
        source.loop = loop;

        let audioContext = getAudioContext();
        let currentTime = audioContext.currentTime;

        gainNode = audioContext.createGain();
        gainNode.connect(audioContext.destination);

        gainNode.gain.setValueAtTime(0, currentTime);
        gainNode.gain.linearRampToValueAtTime(volume, currentTime + 0.01);
        source.connect(gainNode);
        source.start();
    }

    function pause() {
        try {
            source.stop();
        } catch (err) {
        }
    }

    async function init() {
        buffer = await prepareMetronomeLegacy(bpm, timeSignatureMeter);
    }

    await init();

    return {
        play: play,
        pause: pause,
        stop: stop,
        changeVolume: changeVolume,
        mute: mute,
        unmute: unmute
    };
}


export function getMinLatency(bpm, numBeats, threshold) {
    let res = 60 / bpm * 1000;
    let prevRes = res;
    for (let i = 0; i < 8; i++) {
        if (numBeats % 2 === 0) {
            res = res / (numBeats / 2);
        } else {
            res = res / numBeats;
        }

        if (res < threshold) {
            return prevRes;
        }
        prevRes = res;
    }
    return 0;
}


export function roundBpm(bpm) {
    if (isNumber(bpm)) {
        return Math.round(bpm);
    }
    return null;
}

export function ceilTwoDecimal(value) {
    return Math.ceil(Math.floor(value * 100) / 100);
}

export const startMicrophone = async () => {
    const {inputDeviceId} = recorderStore;
    const stream = getStreamIfAvailable();
    if (isIos() && stream) {
        return stream;
    }
    let constraints = {};
    if (isIos()) {
        constraints.audio = true;
    } else {
        constraints.audio = {
            // optional: {
            //     echoCancellation: false,
            //     autoGainControl: false,
            // },
            echoCancellation: false,
            autoGainControl: false,
            googEchoCancellation: false,
            googAutoGainControl: false,
            googNoiseSuppression: false,
            googHighpassFilter: false,
            googTypingNoiseDetection: false
        };
        if (inputDeviceId) {
            constraints.audio.deviceId = inputDeviceId;
        } else {
            constraints.audio.deviceId = 'default';
        }
    }

    return navigator.mediaDevices.getUserMedia(constraints);
};

const latencyNumClicks = 3;
const latencyClickFrequency = 3;

export class AudioRecorder {
    stream = null;
    source = null;
    monitor = null;
    script = null;
    recording = false;
    disabledRecord = false;

    allTimeMax = 0.5;

    onaudioprocessCb = null;
    onDoneRecoding = null;

    recordedPages = [];
    output = null;

    recordingBufferSize = 4096;
    latencyTestBufferSize = 16384;
    num = 0;
    outputTimes = [];
    inputTimes = [];
    doneSending = false;

    latencyTestSensitivity = device.iphone() ? 0.15 : 0.12;
    latencyTestVolume = device.iphone() ? 20 : 1;


    audioContext = null;

    constructor(bpm, onaudioprocessCb, onDoneRecoding) {
        this.onaudioprocessCb = onaudioprocessCb;
        this.onDoneRecoding = onDoneRecoding;
        this.bpm = bpm;
        this.initInternals();
    }

    getTotalLatency() {
        if (isNumber(getDeviceLatency())) {
            return getDeviceLatency();
        }
        if (device.mobile()) {
            return 0.025;
        }
        return isMacOs() ? 0.025 : 0.126;
    }

    runLatencyTest = async () => {
        await prepareMetronomeNoGap();
        this.recording = true;
        if (this.script) {
            this.script.onaudioprocess = null;
        }
        this.disabledRecord = false;
        this.script = this.audioContext.createScriptProcessor(this.latencyTestBufferSize, 1, 1);
        this.monitor = this.audioContext.createGain();
        this.monitor.gain.setTargetAtTime(this.latencyTestVolume, 0, 0.01);

        this.script.connect(this.monitor);

        this.num = 0;
        this.inputTimes = [];
        this.outputTimes = [];
        this.doneSending = false;

        this.script.onaudioprocess = this.onaudioprocessLatency;
        this.monitor.connect(this.audioContext.destination);
        this.source.connect(this.script);
        this.startTime = this.audioContext.currentTime;

    };

    onaudioprocess = async e => {
        const max = this.getMaxVolume(e);
        this.onaudioprocessCb(max, allowPlayback());
    };


    onaudioprocessLatency = e => {
        e.outputBuffer.getChannelData(0).set(new Float32Array(this.latencyTestBufferSize));
        // console.log(Math.max(...e.inputBuffer.getChannelData(0)));
        for (let i = 0; i < e.inputBuffer.getChannelData(0).length; i++) {
            if (e.inputBuffer.getChannelData(0)[i] > this.latencyTestSensitivity) {
                this.inputTimes.push(this.num * this.latencyTestBufferSize + i);
                break;
            }
        }
        if (!this.doneSending) {
            if (this.num % latencyClickFrequency === 0) {
                copyBuffer(e.outputBuffer, metronomeSoundBufferNoGap, 0, 0, this.latencyTestBufferSize / 4);
                let delay = isFirefox() ? 0 : 2;
                this.outputTimes.push((this.num + delay) * this.latencyTestBufferSize + this.latencyTestBufferSize / 4);
            }
        } else if (this.num > latencyClickFrequency * latencyNumClicks + 1) {
            console.log(this.outputTimes);
            console.log(this.inputTimes);
            this.script.onaudioprocess = null;
            this.script.disconnect();
            let result = this.interpeteLatencyResults(this.inputTimes, this.outputTimes);
            this.onDoneRecoding(result);
        }
        this.doneSending = this.outputTimes.length === 3;
        this.num++;
    };


    getFirstDiffAfter(array, after) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] > after) {
                return array[i] - after;
            }
        }
    }

    interpeteLatencyResults(inputs, outputs) {
        let result = {};
        if (inputs.length < outputs.length) {
            result.err = 'Too few inputs detected, sent: ' + outputs.length + ' received: ' + inputs.length;
            result.errCode = LatencyTestError.TooLittle;
            result.success = false;
        }
        if (inputs.length >= outputs.length) {
            let diff = [];
            for (let i = 0; i < outputs.length; i++) {
                diff.push(this.getFirstDiffAfter(inputs, outputs[i]));
            }
            console.log('diffs: ' + diff);
            const min = Math.min(...diff);
            const max = Math.max(...diff);
            const avg = mean(diff);
            if (max - min <= 5000) {
                result.latencyFrames = avg;
                result.latencyMs = avg / this.audioContext.sampleRate;
                result.success = true;
            } else {
                result.err = 'Inconclusive results: max: ' + max + ', min: ' + min + ', avg: ' + avg;
                result.errCode = LatencyTestError.Unstable;
                result.success = false;
            }
        }
        return result;
    }

    onaudioprocessRecord = e => {
        if (!this.disabledRecord) {
            let buffer = this.audioContext.createBuffer(e.inputBuffer.numberOfChannels, this.recordingBufferSize, e.inputBuffer.sampleRate);
            copyBuffer(buffer, e.inputBuffer);
            this.recordedPages.push(buffer);
        }
        const max = this.getMaxVolume(e);
        this.onaudioprocessCb(max);
    };

    getMaxVolume = (e) => {
        let max = 0;
        for (let i = 0; i < e.inputBuffer.numberOfChannels; i++) {
            let buffer = e.inputBuffer.getChannelData(i);
            for (let j = 0; j < buffer.length; j++) {
                max = buffer[j] > max ? buffer[j] : max;
            }
        }
        // this.allTimeMax = Math.max(this.allTimeMax, max);
        // return max / this.allTimeMax;
        return max * (isIos() ? 3 : 1);
    };

    // closeAudioContext = async () => {
    //     if (this.audioContext) {
    //         try {
    //             await this.audioContext.close();
    //         } catch (err) {
    //         }
    //     }
    // };
    //
    _onStreamInit = async (stream) => {
        // await this.closeAudioContext();
        // this.audioContext = getAudioContext();
        this.source = this.audioContext.createMediaStreamSource(stream);
        this.script = this.audioContext.createScriptProcessor(4096, 1, 1);
        this.monitor = this.audioContext.createGain();
        this.monitor.gain.setTargetAtTime(recorderStore.monitorIsActive ? 1 : 0, 0, 0.01);
        this.source.connect(this.script);
        this.source.connect(this.monitor);
        this.monitor.connect(this.audioContext.destination);
        this.script.onaudioprocess = this.onaudioprocess;
        this.script.connect(this.audioContext.destination);
        return stream;
    };

    init = async () => {
        try {
            this.initInternals();
            this.audioContext = getAudioContext();
            let stream = await startMicrophone();
            this.stream = stream.clone();
            await this._onStreamInit(this.stream);
        } catch (err) {
            console.log('err reading stream', err);
            throw err;
        }
    };

    disableCallback = () => {
        this.disabledRecord = true;
        // if (this.script && this.script.onaudioprocess) {
        //     this.script.onaudioprocess = null
        // }
    };

    setMonitorState = (monitorState) => {
        if (this.monitor && this.monitor.gain) {
            if (monitorState) {
                this.monitor.gain.setTargetAtTime(1, 0, 0.01);
            } else {
                this.monitor.gain.setTargetAtTime(0, 0, 0.01);
            }
        }
    };

    prepareToRecord = () => {
        // this.audioContext = ;
        this.recording = true;
        this.script.onaudioprocess = null;
        this.disabledRecord = false;
        this.script = this.audioContext.createScriptProcessor(this.recordingBufferSize, 2, 2);
        this.script.onaudioprocess = this.onaudioprocessRecord;
        this.script.connect(this.audioContext.destination);
        this.source.connect(this.script);
        this.startTime = this.audioContext.currentTime;
        console.log('prepare to record:', this.startTime);
    };

    record = () => {
        this.recordTime = this.audioContext.currentTime;
        console.log('record:', this.recordTime);
    }


    stop = () => {
        let sampleRate = this.audioContext.sampleRate;
        this.endTime = this.audioContext.currentTime;
        console.log('stop:', this.endTime);
        this.recording = false;
        if (this.script) {
            this.disabledRecord = true;
            // this.script.onaudioprocess = null;
        }

        let duration = this.endTime - this.recordTime;
        let skipSamples = (this.recordTime - this.startTime + this.getTotalLatency()) * sampleRate;
        // skipSamples = 0;
        // console.log('skipping samples: ' + skipSamples);
        console.log('skipping samples: ' + skipSamples);
        let numSamples = duration * sampleRate - this.getTotalLatency() * sampleRate;
        if (numSamples <= 0) {
            this.onDoneRecoding();
            return;
        }
        this.output = this.audioContext.createBuffer(2, numSamples, sampleRate);
        let length = 0;
        let firstPage = Math.floor(skipSamples / this.recordingBufferSize);
        for (let i = firstPage; i < this.recordedPages.length; i++) {
            if (i === firstPage) {
                if (skipSamples < this.recordingBufferSize * (i + 1)) {
                    copyBuffer(this.output, this.recordedPages[firstPage], null, skipSamples - i * this.recordingBufferSize, 0);
                    length += (i + 1) * this.recordingBufferSize - skipSamples;
                }
                continue;
            } else if (length > numSamples) {
                copyBuffer(this.output, this.recordedPages[i], null, 0, length - numSamples);
            } else {
                copyBuffer(this.output, this.recordedPages[i], null, 0, length);
            }
            length += this.recordingBufferSize;
        }

        // let length = 0;
        // for (let i = 0; i < this.recordedPages.length; i++) {
        //     if (length > numSamples) {
        //         copyBuffer(this.output, this.recordedPages[i], null, 0, length - numSamples);
        //     } else {
        //         copyBuffer(this.output, this.recordedPages[i], null, 0, length);
        //     }
        //     length += this.recordingBufferSize;
        // }
        //
        this.onDoneRecoding();
    };

    initInternals = () => {
        this.recording = false;
        this.startTime = 0;
        this.recordTime = 0;
        this.endTime = 0;
        this.recordedPages = [];
        this.output = null;
        this.allTimeMax = 0.5;

        this.doneSending = false;
        this.inputTimes = [];
        this.outputTimes = [];
        this.num = 0;


        if (this.source) {
            this.source.disconnect();
            this.source = null;
        }
        if (this.monitor) {
            this.monitor.disconnect();
            this.monitor = null;
        }
        if (this.script) {
            this.script.onaudioprocess = undefined;
            this.script.disconnect();
            this.script = null;
        }
        if (this.stream !== null && this.stream) {
            if (this.stream.getTracks) {
                this.stream.getTracks().forEach(function (track) {
                    console.log(track.getConstraints())
                    track.stop();
                });
            } else {
                this.stream.stop();
            }
        }
        this.stream = null;
        // this.closeAudioContext();
    };

    destroy = () => {
        this.initInternals();
    }

}


export function getFileIdWithBpm(object) {
    return object.originalBPM && (object.originalBPM !== object.bpm || object.pitch !== 0) ? `${object.fileId}_${object.bpm}_${object.pitch}` : object.fileId;
}

export function normalizeBpm(bpm) {
    return Math.min(Math.max(bpm, BPM_MIN), BPM_MAX);
}
